import React from "react";

// reactstrap components
import {
    Table,
    Badge,
    Button,
    DropdownMenu,
    DropdownItem,
    Modal,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import ProductDataService from "../../services/ProductDataService";

class ProductEmoney extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            productToDisabled: {},
        }
        this.productDataService = new ProductDataService();
    }

    toggleModal = (product) => {
        this.props.toggleModal("formModal", "edit", product)
    }

    toggleModals = (state, product) => {
        this.setState({
            [state]: !this.state[state],
            productToDisabled: product,
        });
    };

    handleDisableProduct() {
        const status = 1; // Disable product

        this.productDataService.disable({
            ...this.state.productToDisabled,
            status
        }).then((data) => {
            this.handleResponse(data, "E-Money berhasil dinonaktifkan");
        });
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("disableProductModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {} })
            this.props.fetchData()
        }
    }

    isAdmin() {
        return ((localStorage.getItem("user_roles")) || "")
            .split(',')
            .map(role => role.trim().toLowerCase())
            .some(role => role === "admin");
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Nama E-Money</th>
                        <th scope="col">Barcode Produk</th>
                        <th scope="col">Status</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.products.length > 0 && this.props.products.filter(product => product).map((product) => (
                        <tr key={product.product_id} style={{ cursor: 'pointer' }}>
                            <th scope="row" onClick={() => this.toggleModal(product)}>
                                {product.product_name}
                            </th>
                            <td scope="row" onClick={() => this.toggleModal(product)}>
                                {product.product_barcode}
                            </td>
                            <td onClick={() => this.toggleModal(product)}>
                                <Badge color="" className="badge-dot mr-4">
                                    <i className={product.status === 0 ? "bg-info" : "bg-warning"} />
                                    {product.status === 0 ? "Aktif" : "Tidak aktif"}
                                </Badge>
                            </td>
                            <td className="text-right">
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        className="btn-icon-only text-light"
                                        role="button"
                                        size="sm"
                                        color=""
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <i className="fas fa-ellipsis-v" />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-arrow" right>
                                        <DropdownItem
                                            onClick={() => this.toggleModal(product)}
                                        >
                                            Ubah
                                        </DropdownItem>
                                        <DropdownItem
                                            onClick={() => this.toggleModals("disableProductModal", product)}>
                                            Nonaktifkan
                                        </DropdownItem>
                                    </DropdownMenu>
                                    <Modal
                                        className="modal-dialog-centered modal-danger"
                                        contentClassName="bg-gradient-danger"
                                        isOpen={this.state.disableProductModal}
                                        toggle={() => this.toggleModals("disableProductModal")}
                                    >
                                        <div className="modal-header">
                                            <button
                                                aria-label="Close"
                                                className="close"
                                                data-dismiss="modal"
                                                type="button"
                                                onClick={() => this.toggleModals("disableProductModal")}
                                            >
                                                <span aria-hidden={true}>×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="py-3 text-center">
                                                <i className="ni ni-bell-55 ni-3x" />
                                                <h4 className="heading mt-4">Anda akan <strong>menonaktifkan</strong> E-Money berikut</h4>
                                                <p>
                                                    Nama E-Money <b>{this.state.productToDisabled?.product_name}</b>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <Button
                                                className="text-white ml-auto"
                                                color="link"
                                                data-dismiss="modal"
                                                type="button"
                                                onClick={() => this.toggleModals("disableProductModal")}
                                            >
                                                Batal
                                            </Button>
                                            <Button
                                                className="btn-white"
                                                color="default"
                                                type="button"
                                                onClick={() => this.handleDisableProduct()}
                                            >
                                                Nonaktifkan
                                            </Button>
                                        </div>
                                    </Modal>
                                </UncontrolledDropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default ProductEmoney;
